import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalTemplateComponent } from './modal-template.component';
import { SvgIconModule } from '../svg-icon/svg-icon.module';

@NgModule({
  declarations: [ModalTemplateComponent],
  imports: [CommonModule, SvgIconModule],
  exports: [ModalTemplateComponent],
})
export class ModalTemplateModule {}
